import { createInteractiveColorVars } from '../../helpers/createInteractiveColorVars/index.js';

const SnapchatColors = createInteractiveColorVars('snapchat');
const SnapchatColorsLightValues = Object.freeze({
    base: {
        default: '#FFFC00',
        action: '#ece801',
        active: '#FFFC00',
        activeAction: '#ece801',
    },
    text: {
        default: '#000000',
        action: '#000000',
        active: '#000000',
        activeAction: '#000000',
    },
});
const SnapchatColorsDarkValues = Object.freeze({
    base: {
        default: '#FFFC00',
        action: '#ece801',
        active: '#FFFC00',
        activeAction: '#ece801',
    },
    text: {
        default: '#000000',
        action: '#000000',
        active: '#000000',
        activeAction: '#000000',
    },
});

export { SnapchatColors, SnapchatColorsDarkValues, SnapchatColorsLightValues };
